module.exports = __webpack_public_path__ + "img/logo-yingzhi-2.cff45aff.png";